const CHUNK_ERROR_RETRY_KEY = 'chunk-load-retry'
const CHUNK_ERROR_RETRY_WINDOW_MS = 15000

const getErrorMessage = (error) => {
    if (!error) {
        return ''
    }

    if (typeof error === 'string') {
        return error
    }

    return `${error.name || ''} ${error.message || ''}`.trim()
}

export const isChunkLoadError = (error) => {
    const message = getErrorMessage(error).toLowerCase()

    return (
        message.includes('chunkloaderror') ||
        message.includes('loading chunk') ||
        message.includes('loading css chunk') ||
        message.includes('failed to fetch dynamically imported module')
    )
}

const getRetryState = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CHUNK_ERROR_RETRY_KEY) || 'null')
    } catch (error) {
        return null
    }
}

const setRetryState = (state) => {
    try {
        sessionStorage.setItem(CHUNK_ERROR_RETRY_KEY, JSON.stringify(state))
    } catch (error) {
        // Ignore storage failures and fall back to a best-effort reload.
    }
}

export const shouldRetryChunkLoad = (error) => {
    const message = getErrorMessage(error)
    const now = Date.now()
    const retryState = getRetryState()

    if (
        retryState &&
        retryState.message === message &&
        now - retryState.timestamp < CHUNK_ERROR_RETRY_WINDOW_MS
    ) {
        return false
    }

    setRetryState({
        message,
        timestamp: now,
    })

    return true
}
